module.exports = __webpack_public_path__ + "img/cover4.8c9e3779.png";